import type { DirectiveBinding, Directive } from 'vue'

type CustomElement = (HTMLInputElement | HTMLTextAreaElement) & {
  __enter_composing: boolean
  __enter_remove?: () => void
}

const onCompositionStart = (e: Event) => ((e.target as CustomElement).__enter_composing = true)
const onCompositionEnd = (e: Event) => ((e.target as CustomElement).__enter_composing = false)

export const vEnter: Directive = {
  beforeMount(el: CustomElement, binding: DirectiveBinding) {
    if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
      el.addEventListener('compositionstart', onCompositionStart)
      el.addEventListener('compositionend', onCompositionEnd)

      const onKeydown = (e: Event) => {
        if (
          e instanceof KeyboardEvent &&
          e.keyCode === 13 &&
          !(e.target as CustomElement).__enter_composing
        ) {
          binding.value(e)
        }
      }

      el.addEventListener('keydown', onKeydown)
      el.__enter_remove = () => el.removeEventListener('keydown', onKeydown)
    }
  },

  beforeUnmount(el: CustomElement) {
    el.addEventListener('compositionstart', onCompositionStart)
    el.addEventListener('compositionend', onCompositionEnd)
    if (el.__enter_remove) el.__enter_remove()
  },
}
